// Canonical payment-methods catalog used across the whole app.
//
// channel:
//   - "mercadopago": cobrança online via Mercado Pago (Pix, Cartão, Boleto).
//   - "presencial" : recebimento no balcão → entra direto no Caixa como pago.
//   - "comprovante": Pix com envio de comprovante por WhatsApp (fluxo manual).

export type PaymentChannel = "mercadopago" | "presencial" | "comprovante";

export interface PaymentMethodDef {
  value: string;
  label: string;
  channel: PaymentChannel;
}

export const PAYMENT_METHODS: readonly PaymentMethodDef[] = [
  // Online (Mercado Pago)
  { value: "pix",              label: "Pix",                       channel: "mercadopago" },
  { value: "cartao_credito",   label: "Cartão de Crédito",         channel: "mercadopago" },
  // Comprovante manual
  { value: "pix_comprovante",  label: "Pix (Enviar comprovante)",  channel: "comprovante" },
  // Presencial (vai direto pro caixa)
  { value: "dinheiro",         label: "Dinheiro (Presencial)",     channel: "presencial" },
  { value: "cartao_presencial", label: "Cartão (Presencial)",      channel: "presencial" },
  { value: "pix_presencial",   label: "Pix (Presencial)",          channel: "presencial" },
] as const;

export type PaymentMethodValue = (typeof PAYMENT_METHODS)[number]["value"];

export const PAYMENT_CHANNEL_LABELS: Record<PaymentChannel, string> = {
  mercadopago: "Online (Mercado Pago)",
  comprovante: "Pix com comprovante",
  presencial:  "Presencial (entra direto no caixa)",
};

export const paymentMethodLabel = (v: string) =>
  PAYMENT_METHODS.find((m) => m.value === v)?.label ?? v;

export const paymentMethodChannel = (v: string): PaymentChannel | null =>
  PAYMENT_METHODS.find((m) => m.value === v)?.channel ?? null;

export const isMercadoPagoMethod = (v: string) =>
  paymentMethodChannel(v) === "mercadopago";

export const isPresencialMethod = (v: string) =>
  paymentMethodChannel(v) === "presencial";

export const isComprovanteMethod = (v: string) =>
  paymentMethodChannel(v) === "comprovante";
